import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=9a8adf30&scoped=true"
import script from "./Home.ts?vue&type=script&lang=js&external"
export * from "./Home.ts?vue&type=script&lang=js&external"
import style0 from "./Home.vue?vue&type=style&index=0&id=9a8adf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8adf30",
  null
  
)

export default component.exports